import { createSelector } from 'reselect';
import metaSelector from 'Selectors/metaSelector';

const forumviewSelector = state => ( state.forumview.forumId ? state.forumview : state.searchresult );
const topifyPresetsSelector = state => state.topifyPresets;
const userStateSelector = state => state.ustate;
const uiStateSelector = state => state.ui;

export default createSelector(
	[forumviewSelector, metaSelector, topifyPresetsSelector, userStateSelector, uiStateSelector],
	(forumview, meta, topifyPresets, ustate, ui) => {
		return {
			forumview: forumview,
			meta: meta,
			ustate: ustate,
			userSettings: ui.userSettings,
			forumSite: topifyPresets.forumSite,
			firstLoad: topifyPresets.firstLoad,
			initialRoute: topifyPresets.initialRoute,
			initialId: topifyPresets.initialId,
			secondayId: topifyPresets.secondayId
		}
	}
);



// WEBPACK FOOTER //
// ./src/selectors/forumViewSelector.js